import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PÁGINA DE USUARIO BLOQUEADO
 * 
 * Se muestra cuando un usuario intenta iniciar sesión pero su cuenta
 * está bloqueada (userStatus === 2).
 * 
 */

const UserBlocked = () => {
  const navigate = useNavigate();
  
  const handleGoToLogin = () => {
    // Limpiar cualquier sesión residual
    sessionStorage.removeItem('userSession');
    navigate('/login');
  };
  
  return (
    <div className="min-h-screen w-full bg-black/40 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card*/}
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden animate-fade-in">
          
          {/* Contenido */}
          <div className="px-8 py-10 text-center">
            {/* Ícono de advertencia */}
            <div className="w-20 h-20 mx-auto mb-6 border-4 border-orange-400 rounded-full flex items-center justify-center">
              <span className="text-orange-400 text-6xl font-bold">!</span>
            </div>
            
            {/* Título */}
            <h1 className="text-2xl font-semibold text-gray-800 mb-4">
              Usuario bloqueado
            </h1>
            
            {/* Mensaje */}
            <p className="text-gray-600 text-base mb-8 leading-relaxed">
              Su cuenta ha sido bloqueada. Contacte al administrador para más información.
            </p>
            
            {/* Botón de acción */}
            <button
              onClick={handleGoToLogin}
              className="w-full px-8 py-3 text-white font-medium rounded shadow-md transition-all duration-200 hover:shadow-lg"
              style={{ backgroundColor: '#CC0000' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#B00000'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#CC0000'}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBlocked;
